import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { CardData } from "../../types/card.type";
import { User2 } from "lucide-react";

interface AllCardsOwnerProps {
  card: CardData;
}

const AllCardsOwner = ({ card }: AllCardsOwnerProps) => {
  return (
    <div className="flex items-center gap-2 w-max">
      <ImageWithPlaceholder
        className="w-6 h-6"
        iconClassName="w-4 h-4"
        placeholderIcon={User2}
        url={card.owner?.profile_picture?.url}
      />

      <div className="flex flex-col">
        <p>{card.owner?.full_name}</p>
        <p className="text-[11px] font-light text-white-300 italic">Usuário</p>
      </div>
    </div>
  );
};

export default AllCardsOwner;
